import React from 'react'

export default function Helpers() {
  return (
    <section>
      <a className="anchor" id="helpers"></a>
      <h2>Helpers</h2>

      <p>A series of helper classes to use arbitrarily. A lot of these classes carry '!important' to win out over other selectors. While adding lots of helpers can lead to 'ugly' html where the elements become overloaded with many classes, this is one of the most maintainable and traceable pattern for scalable CSS</p>

      <h3>Add/remove Floats</h3>
      <div className="callout callout--secondary">
        <span>
          <i className="fa fa-exclamation"></i>
          Floats do
          <b>&nbsp;not&nbsp;</b>
          work when the flex grid is involved - use the flex classes to achieve the same result.</span>
      </div>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">
          <p className="float--none push-half--bottom">Float none</p>
          <p className="float--right push-half--bottom">Float right</p>
          <p className="float--left push-half--bottom">Float left</p>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.float--none
.float--right
.float--left`}</code></pre>
        </div>
      </div>
      <hr/>

      <h3>Text aligment</h3>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">
          <p className="text--left push-half--bottom">Text left</p>
          <p className="text--center push-half--bottom">Text center</p>
          <p className="text--right push-half--bottom">Text right</p>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.text--left
.text--center
.text--right`}</code></pre>
        </div>
      </div>
      <br/><hr/>

      <h3>Font weights</h3>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">
          <p className="weight--light push-half--bottom">Weight light</p>
          <p className="weight--normal push-half--bottom">Weight normal</p>
          <p className="weight--semibold push-half--bottom">Weight semibold</p>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-html">{`.weight--light
.weight--normal
.weight--semibold`}</code></pre>
        </div>
      </div>
      <hr/>

<h3>Lists</h3>

<h4>Dotted list</h4>

<div className="grid grid--align-center">
  <div className="grid__col-xs-12 grid__col-sm-6">

    <ul className="list-dotted">
      <li>List item 1</li>
      <li>List item 2</li>
      <li>List item 3</li>
    </ul>

  </div>
  <div className="grid__col-xs-12 grid__col-sm-6">
    <pre><code className="language-html">
      {
`<ul class="list-dotted">
  <li>List item 1</li>
  <li>List item 2</li>
  <li>List item 3</li>
</ul>`
      }
    </code></pre>
  </div>
</div>

<h4>Decimal list</h4>

<div className="grid grid--align-center">
  <div className="grid__col-xs-12 grid__col-sm-6">

    <ol className="list-decimal">
      <li>List item 1</li>
      <li>List item 2</li>
      <li>List item 3</li>
    </ol>

  </div>
  <div className="grid__col-xs-12 grid__col-sm-6">
    <pre><code className="language-html">
      {
`<ol class="list-decimal">
  <li>List item 1</li>
  <li>List item 2</li>
  <li>List item 3</li>
</ol>`
      }
    </code></pre>
  </div>
</div>




      <h3>Add/Remove margins</h3>

      <h4>Add Full Margins</h4>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="margins-demo">
            <div className="margins-demo__item push--left">Push Left</div>
          </div>
          <div className="margins-demo">
            <div className="margins-demo__item push--sides">Push Sides</div>
          </div>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.push
.push--top
.push--right
.push--bottom
.push--left
.push--ends
.push--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
      <hr/>

      <h4>Add Half Margins</h4>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="margins-demo">
            <div className="margins-demo__item push-half--left">Push Half Left</div>
          </div>
          <div className="margins-demo">
            <div className="margins-demo__item push-half--sides">Push Half Sides</div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.push-half
.push-half--top
.push-half--right
.push-half--bottom
.push-half--left
.push-half--ends
.push-half--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
      <hr/>

      <h4>Remove Margins</h4>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="margins-demo">
            <div className="margins-demo__item  margins-demo--full-margin flush--left">Flush Left</div>
          </div>
          <div className="margins-demo">
            <div className="margins-demo__item margins-demo--full-margin flush--sides">Flush Sides</div>
          </div>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">

          <pre><code className="language-css">{`.flush
.flush--top
.flush--right
.flush--bottom
.flush--left
.flush--ends
.flush--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>

        </div>
      </div>
      <hr/>

      <h3>Add/Remove paddings</h3>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">
          <div className="paddings-demo">
            <div className="paddings-demo__item soft--left">Soft Left</div>
          </div>
          <div className="paddings-demo">
            <div className="paddings-demo__item soft--sides">Soft Sides</div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.soft
.soft--top
.soft--right
.soft--bottom
.soft--left
.soft--ends
.soft--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
      <hr/>

      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="paddings-demo">
            <div className="paddings-demo__item soft-half--left">Soft Half Left</div>
          </div>
          <div className="paddings-demo">
            <div className="paddings-demo__item soft-half--sides">Soft Half Sides</div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.soft-half
.soft-half--top
.soft-half--right
.soft-half--bottom
.soft-half--left
.soft-half--ends
.soft-half--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
      <hr/>

      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="paddings-demo">
            <div className="paddings-demo__item soft-quarter--left">Soft Quarter Left</div>
          </div>
          <div className="paddings-demo">
            <div className="paddings-demo__item soft-quarter--sides">Soft Quarter Sides</div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.soft-quarter
.soft-quarter--top
.soft-quarter--right
.soft-quarter--bottom
.soft-quarter--left
.soft-quarter--ends
.soft-quarter--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
      <hr/>

      <h4>Remove Padding</h4>
      <div className="grid grid--align-center">
        <div className="grid__col-xs-12 grid__col-sm-6">

          <div className="paddings-demo">
            <div className="paddings-demo__item  paddings-demo--full-padding hard--left">Hard Left</div>
          </div>
          <div className="paddings-demo">
            <div className="paddings-demo__item paddings-demo--full-padding hard--sides">Hard Sides</div>
          </div>
        </div>
        <div className="grid__col-xs-12 grid__col-sm-6">
          <pre><code className="language-css">{`.hard
.hard--top
.hard--right
.hard--bottom
.hard--left
.hard--ends
.hard--sides

Responsive variants:
--xs-only, --sm-only, --sm-and-up, --md-only,
--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,
--palm, --lap, --lap-and-up,
--portable, --desk`}</code></pre>
        </div>
      </div>
<br/><br/>
      <h3>Display Helpers</h3>
      <pre><code className="language-css">{`.display--block
.display--inline-block
.display--flex
.display--table
.display--table-cell`}</code></pre>
<br/><br/>
<h3>Position Helpers</h3>
<pre><code className="language-css">{`.position--static
.position--relative
.position--fixed
.position--absolute`}</code></pre>
<br/><br/>
<h3>Clearfix</h3>
<pre><code className="language-css">{`.clearfix
.clear--left
.clear--right
.clear--both`}</code></pre>
<br/><br/>
<h3>Center</h3>
<p>IE behaves differently when centering content displayed with inline-block. This helper normalises the differences.</p>
<pre><code className="language-css">.center</code></pre>
<br/><br/>
<h3>Show / Hide</h3>
<p>.hide will make content 'inaccessible' to screenreaders, .visuallyhidden will allow the element to be hidden but accessible.</p>
<pre><code className="language-css">{`.hide
.visuallyhidden`}</code></pre>

<pre><code className="language-css">{`// Visually hidden variants

.visuallyhidden--xs-only
.visuallyhidden--sm-only
.visuallyhidden--sm-and-up
.visuallyhidden--md-only
.visuallyhidden--md-and-up
.visuallyhidden--lg-only
.visuallyhidden--lg-and-up
.visuallyhidden--xlg-and-up

.visuallyhidden--palm
.visuallyhidden--lap
.visuallyhidden--lap-and-up
.visuallyhidden--portable
.visuallyhidden--desk

.visuallyhidden--retina`}</code></pre>

<pre><code className="language-css">{`// hide variants

.hide--xs-only
.hide--sm-only
.hide--sm-and-up
.hide--md-only
.hide--md-and-up
.hide--lg-only
.hide--lg-and-up
.hide--xlg-and-up

.hide--palm
.hide--lap
.hide--lap-and-up
.hide--portable
.hide--desk

.hide--retina`}</code></pre>
<br/><br/>
<h3>Max width</h3>
<pre><code className="language-css">{`.max-width--10 // percent
.max-width--20
.max-width--30
.max-width--40
.max-width--50
.max-width--60
.max-width--70
.max-width--80
.max-width--90
.max-width--100

.max-width-xs // matches grid breakpoints
.max-width-sm
.max-width-md
.max-width-lg
.max-width-xl`}</code></pre>
<br/><br/>
<h3>Text fix</h3>
<p>If you find your text is jumbled and too close together, it is a side effect of the grid system. <b>It is likely you have content inside a grid, but not inside a column.</b></p>
<div className="callout callout--secondary">
  <span>
  <i className="fa fa-exclamation"></i>
  There is limited use cases for this class, its almost certainly an indicator you should check you have a valid grid layout.
  </span>
</div>
<br/>
<pre><code className="language-css">{`.fix-text`}</code></pre>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Helpers.js